module.exports = __webpack_public_path__ + "img/UTGOBL-3.86a46e39.jpg";